import jwtDecode from 'jwt-decode';
import React, { useMemo, useRef, useEffect, useState } from "react";
import { format } from "date-fns";
import { initializeApp } from 'firebase/app';
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { NumericFormat } from "react-number-format";
import "./style.scss";
import report from '../../api/report';
import OTP from '../../api/OTP';
import ResultModal from '../ResultModal';
import { vietnamEndOfTodayUnix, vietnamStartOfTodayUnix, vietnamUnixFromDate } from '../../helpers/date';

const app = initializeApp({
  apiKey: "AIzaSyDUi4uAVqEpG4hyTBNqoEZvQEGP9ZSue8g",
  authDomain: "arabica-worker.firebaseapp.com",
  projectId: "arabica-worker",
  storageBucket: "arabica-worker.appspot.com",
  messagingSenderId: "474953153749",
  appId: "1:474953153749:web:70885fdf6b6315c94bf65c",
  measurementId: "G-PYGR5N3GTT"
});

const auth = getAuth(app);
auth.languageCode = 'vi';


export default function Modal({ payload, handleClose, handleSubmit, result }) {
  const [otp, setOTP] = useState('');
  const [resultMessage, setResultMessage] = useState('');
  const optRef = useRef(null);
  // startTime,
  // endTime,
  // branch,
  // cashData,
  // vnPay,
  // shopeeFood,
  // grabFood,
  // cardData,
  // cashReturnData,
  // voucher,
  // endOptions,
  // requestChange
  const cashTotal = payload.cashData.reduce(
    (total, item) => (total += item.subtotal),
    0
  );
  const cashReturnTotal = payload.cashReturnData.reduce(
    (total, item) => (total += item.subtotal),
    0
  );

  const [openResultModal, setOpenResult] = useState(false);
  const [dataResult, setDataResult] = useState([]);

  const cardTotal = useMemo(() => {
    if (payload.cardData) {
      const textValue = payload.cardData;
      const text = textValue.replaceAll('\n', ' ');
      let total = 0;
      const numbers = text.split(' ').map(item => {
        const num = Number(item);
        if (num > 0) {
          total += num;
          return num;
        }
      });

      return total;
    }
    return 0;
  }, [payload.cardData]);

  const vnPayQRTotal = useMemo(() => {
    if (payload.vnPay) {
      const textValue = payload.vnPay;
      const text = textValue.replaceAll('\n', ' ');
      let total = 0;
      text.split(' ').map(item => {
        const num = Number(item);
        if (num > 0) {
          total += num;
          return num;
        }
      });

      return total;
    }
    return 0;
  }, [payload.vnPay]);

  const shopeeFoodTotal = useMemo(() => {
    if (payload.shopeeFood) {
      const textValue = payload.shopeeFood;
      const text = textValue.replaceAll('\n', ' ');
      let total = 0;
      text.split(' ').map(item => {
        const num = Number(item);
        if (num > 0) {
          total += num;
          return num;
        }
      });

      return total;
    }
    return 0;
  }, [payload.shopeeFood]);

  const grabFoodTotal = useMemo(() => {
    if (payload.grabFood) {
      const textValue = payload.grabFood;
      const text = textValue.replaceAll('\n', ' ');
      let total = 0;
      text.split(' ').map(item => {
        const num = Number(item);
        if (num > 0) {
          total += num;
          return num;
        }
      });

      return total;
    }
    return 0;
  }, [payload.grabFood]);

  const grabDineInTotal = useMemo(() => {
    if (payload.grabDineIn) {
      const text = payload.grabDineIn.replaceAll('\n', ' ');
      let total = 0;
      text.split(' ').forEach(item => {
        const num = Number(item);
        if (num > 0) total += num;
      });
      return total;
    }
    return 0;
  }, [payload.grabDineIn]);

  const befoodTotal = useMemo(() => {
    if (payload.befood) {
      const text = payload.befood.replaceAll('\n', ' ');
      let total = 0;
      text.split(' ').forEach(item => {
        const num = Number(item);
        if (num > 0) total += num;
      });
      return total;
    }
    return 0;
  }, [payload.befood]);
  
  console.log(cardTotal,vnPayQRTotal, shopeeFoodTotal, grabFoodTotal);

  const token = localStorage.getItem('token');
  let jwtData = jwtDecode(token);
  localStorage.setItem('current_user', jwtData.Name);

  const [otpMessage, setOTPMessage] = useState('');
  let [confirmFunction, setConfirmFunction] = useState({
    confirm: () => Promise.resolve(false)
  });

  function sendOTP() {
    OTP.sendOTP().then(res => {
      if (res.message) {
        setResultMessage(res.message);
      }
    })
  }

  function checkOTP() {
    OTP.validate(otp).then(res => {
      if (res?.message === 'success') {
        // cardTotal,vnPayQRTotal, shopeeFoodTotal, grabFoodTotal
        report.endShift({
          startTimestamp: vietnamStartOfTodayUnix(),
          endTimestamp: vietnamEndOfTodayUnix(),
          storeId: payload?.branch?.value,
          cash: cashTotal,
          card: cardTotal,
          vnpay_qr_total: vnPayQRTotal,
          shopeeFood: shopeeFoodTotal,
          grabFood: grabFoodTotal,
          grabDineIn: grabDineInTotal,
          befood: befoodTotal,
          other: payload.appData,
          voucher: payload.voucher,
          cashReturn: cashReturnTotal,
          googleToken: '',
          single: payload?.endOptions?.value || false,
          requestChange: payload?.requestChange || []
        }).then(res => {
          if (res && res?.inputMoney && res?.actualMoney) {
            const result = [{
              method: 'Tiền mặt',
              input: res?.inputMoney.cash,
              actual: res?.actualMoney.cash,
              wrong: res?.inputMoney.cash - res?.actualMoney.cash
            }, {
              method: 'Quẹt thẻ POS Card',
              input: res?.inputMoney.card,
              actual: res?.actualMoney.card,
              wrong: res?.inputMoney.card - res?.actualMoney.card
            }, {
              method: 'VNPay QR (Chuyển khoản)',
              input: res?.inputMoney.vnpay_qr_total,
              actual: res?.actualMoney.vnPayQR,
              wrong: res?.inputMoney.vnpay_qr_total - res?.actualMoney.vnPayQR
            },  {
              method: 'Shopee Food Total',
              input: res?.inputMoney.shopeeFood,
              actual: res?.actualMoney.shopeeFood,
              wrong: res?.inputMoney.shopeeFood - res?.actualMoney.shopeeFood
            },  {
              method: 'GrabFood Total',
              input: res?.inputMoney.grabFood,
              actual: res?.actualMoney.grabFood,
              wrong: res?.inputMoney.grabFood - res?.actualMoney.grabFood
            }, {
              method: 'Grab Dine-in Total',
              input: res?.inputMoney.grabDineIn || 0,
              actual: res?.actualMoney.grabDineIn || 0,
              wrong: (res?.inputMoney.grabDineIn || 0) - (res?.actualMoney.grabDineIn || 0)
            }, {
              method: 'BEFOOD Total',
              input: res?.inputMoney.befood || 0,
              actual: res?.actualMoney.befood || 0,
              wrong: (res?.inputMoney.befood || 0) - (res?.actualMoney.befood || 0)
            }, {
              method: 'Voucher',
              input: res?.inputMoney.voucher,
              actual: res?.actualMoney.voucher,
              wrong: res?.inputMoney.voucher - res?.actualMoney.voucher
            }];
            setDataResult(result);
          }
          setOpenResult(true);
        })
      } else {
        setOTPMessage('Mã xác thực không hợp lệ.');
      }
    }).catch(err => {
      setOTPMessage('Mã xác thực không hợp lệ.');
    });


  }

  useEffect(() => {
    setTimeout(() => {
      sendOTP();
    }, 1000);
  }, []);
  const mapChange = {
    cancel: 'Hủy đơn hàng'
  };

  return (
    <div className="modal-wrap">
      <div className="modal">
        <div className="modal-heading">
          <span>Xác nhận chốt ca</span>
        </div>
        <div className="modal-body">
          <p>
            Chi nhánh: <strong>{payload.branch?.label}</strong>
          </p>
          <p>
            Bắt đầu: <strong>{format(payload.startTime, "h:mm aa")}</strong>
          </p>
          <p>
            Kết thúc: <strong>{format(payload.endTime, "h:mm aa")}</strong>
          </p>
          <p>
            Hình thức chốt ca: <strong>{payload?.endOptions?.label}</strong>
          </p>

          <table>
            <tr>
              <td><strong>Tiền mặt đầu ca làm việc: </strong></td>
              <td>
                <NumericFormat
                  value={cashReturnTotal}
                  thousandSeparator={true}
                  displayType="text"
                />
              </td>
            </tr>
            <tr>
              <td><strong>Tổng tiền mặt: </strong></td>
              <td>
                <NumericFormat
                  value={cashTotal}
                  thousandSeparator={true}
                  displayType="text"
                />
              </td>
            </tr>
            <tr>
              <td><strong>Tổng tiền thanh toán quẹt thẻ POS: </strong></td>
              <td>
                <NumericFormat
                  value={cardTotal}
                  thousandSeparator={true}
                  displayType="text"
                />
              </td>
            </tr>
            <tr>
              <td><strong>Tổng tiền thanh toán VNPay QR </strong></td>
              <td>
                <NumericFormat
                  value={payload.vnPay}
                  thousandSeparator={true}
                  displayType="text"
                />
              </td>
            </tr>
            <tr>
              <td><strong>Tổng tiền thanh toán ShopeeFood </strong></td>
              <td>
                <NumericFormat
                  value={payload.shopeeFood}
                  thousandSeparator={true}
                  displayType="text"
                />
              </td>
            </tr>
            <tr>
              <td><strong>Tổng tiền thanh toán GrabFood </strong></td>
              <td>
                <NumericFormat
                  value={payload.grabFood}
                  thousandSeparator={true}
                  displayType="text"
                />
              </td>
            </tr>
            <tr>
              <td><strong>Tổng tiền thanh toán Grab Dine-in </strong></td>
              <td>
                <NumericFormat
                  value={grabDineInTotal}
                  thousandSeparator={true}
                  displayType="text"
                />
              </td>
            </tr>
            <tr>
              <td><strong>Tổng tiền thanh toán BEFOOD </strong></td>
              <td>
                <NumericFormat
                  value={befoodTotal}
                  thousandSeparator={true}
                  displayType="text"
                />
              </td>
            </tr>
  
            <tr>
              <td><strong>Tổng tiền voucher: </strong></td>
              <td>
                <NumericFormat
                  value={payload.voucher}
                  thousandSeparator={true}
                  displayType="text"
                />
              </td>
            </tr>

          </table>
          <br />___________________________________________________________________
          <br />
          <strong>CÁC YÊU CẦU THAY ĐỔI TRƯỚC KHI THỰC HIỆN KẾT CA.</strong>
          <div style={{ maxHeight: '120px', overflowY: 'auto' }}>
            <table>
              {payload.requestChange.map(data => {
                return (
                  <tr>
                    <td><strong>{data.code}</strong></td>
                    <td>{mapChange[data.change]}</td>
                    <td>{data.note}</td>
                  </tr>
                );
              })}
            </table>
          </div>
          <div id='recaptcha-container'></div>
          <div className="enter-code">
            <span>{resultMessage}</span>
            <input className="input" type="text" onChange={(e) => {
              setOTP(e.target.value);
              console.log(otp);
            }} />
            {result && <span className="result">{result}</span>}
          </div>
          <p className="note">
            *Lưu ý: Chỉ được chốt ca 1 lần duy nhất trong ngày
          </p>
          <p>{otpMessage}</p>
        </div>

        <div className="modal-footer">
          <button onClick={handleClose}>Đóng</button>
          <button
            className="btn"
            onClick={() => {
              checkOTP();
            }}
          >
            Xác nhận
          </button>
        </div>
      </div>
      {openResultModal && (
        <ResultModal
          payload={{
            startTimestamp: vietnamUnixFromDate(payload.startTime),
            endTimestamp: vietnamUnixFromDate(payload.endTime),
            storeName: payload?.branch?.label || 'null',
            cash: cashTotal,
            card: cardTotal,
            other: payload.appData,
            voucher: payload.voucher,
            ...payload
          }}
          resultData={dataResult}
          handleClose={() => setOpenResult(false)}
          handleSubmit={handleSubmit}
          result={result}
          message=''
        />
      )}
    </div>
  );
}
